export const parseJSON = (value, fallback = null) => {
  try {
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
};

export const canAccess = (permissions = [], permission) => {
  return Array.isArray(permissions) && permissions.includes(permission);
};
